import { useContext } from 'react';
import { Box, Card, Cards, ResponsiveContext } from 'grommet';

const appGrid = {
  columns: {
    xsmall: 'auto',
    small: ['auto', 'auto'],
    medium: { count: 'fit', size: ['1/2', 'auto'] },
    large: { count: 'fit', size: ['1/3', 'auto'] },
    xlarge: { count: 'fit', size: ['1/4', 'auto'] },
  },
  rows: 'small',
  gap: {
    xsmall: 'medium',
    small: 'small',
    medium: 'small',
    large: 'medium',
    xlarge: 'medium',
  },
};

export const ListResults = () => {
  const breakpoint = useContext(ResponsiveContext);

  return (
    <Box gap="medium" pad={{ bottom: 'small'}}>
      <Cards
        columns={appGrid.columns[breakpoint]}
        rows={appGrid.rows}
        gap={appGrid.gap[breakpoint]}
      >
        {app => <Card elevation="medium" key={app.id} />}
      </Cards>
    </Box>
  );
};